export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const triggerReactInputChange = (
  inputElement: HTMLInputElement,
  newValue: string
) => {
  const lastValue = inputElement.value; // 保存旧值
  inputElement.value = newValue; // 设置新值

  const tracker = inputElement._valueTracker;
  if (tracker) {
    tracker.setValue(lastValue); // 重置跟踪器，模拟变化
  }

  const event = new Event("input", { bubbles: true }); // 创建 input 事件
  inputElement.dispatchEvent(event); // 派发事件，触发 onChange
};
